import { render, staticRenderFns } from "./CarryOverDetail.vue?vue&type=template&id=6139ff8a&"
import script from "./CarryOverDetail.vue?vue&type=script&lang=js&"
export * from "./CarryOverDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports